import React from "react";
import Logo from "../assets/images/commaLogo.png";

export function CompletedScreen() {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-gradient-to-br from-white to-blue-50 p-4">
      <header className="absolute left-6 top-6">
        <img src={Logo} alt="COMMA logo" className="h-8 w-auto" />
      </header>
      <div className="flex flex-col items-center">
        <div className="relative">
          <svg
            width="305"
            height="305"
            viewBox="0 0 305 305"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <circle
                cx="152.5"
                cy="157.5"
                r="131.5"
                fill="#4979D1"
                fillOpacity="0.64"
              />
              <circle
                cx="153.247"
                cy="158.247"
                r="117.304"
                fill="white"
                fillOpacity="0.64"
              />
              <circle
                cx="152.5"
                cy="157.5"
                r="97.1307"
                fill="white"
                fillOpacity="0.64"
              />
              <circle cx="153.247" cy="158.247" r="82.9347" fill="white" />
              <path
                d="M198 128.781L136.286 195L108 164.65L115.251 156.869L136.286 179.383L190.749 121L198 128.781Z"
                fill="#4979D1"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="305"
                height="305"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="-5" />
                <feGaussianBlur stdDeviation="10.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <p className="mt-8 max-w-xs text-center text-gray-500">
          You have completed all tasks. A report will now be generated based on
          your responses
        </p>
      </div>
    </div>
  );
}
